import React, { ReactNode } from 'react'
import { Box, Typography, Paper, Button } from '@mui/material'
import LockIcon from '@mui/icons-material/Lock'
import UpgradeDialog from './UpgradeDialog'

interface PermissionOverlayProps {
  children: ReactNode
  isVisible: boolean
  message: string
  onUpgrade?: () => void
}

const PermissionOverlay: React.FC<PermissionOverlayProps> = ({
  children,
  isVisible,
  message,
  onUpgrade,
}) => {
  const [upgradeDialogOpen, setUpgradeDialogOpen] = React.useState(false)

  if (!isVisible) {
    return <>{children}</>
  }

  const _onUpgrade = () => {
    if (onUpgrade) {
      onUpgrade()
    }

    setUpgradeDialogOpen(true)
  }

  return (
    <Box
      sx={{
        position: 'relative',
        height: '100%',
      }}
    >
      <Box sx={{ filter: 'blur(4px)' }}>{children}</Box>
      <Paper
        elevation={0}
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 1,
          gap: 2,
        }}
      >
        <LockIcon sx={{ color: 'warning.main', fontSize: 48 }} />
        <Typography
          variant="body1"
          sx={{
            fontWeight: 'medium',
            textAlign: 'center',
            maxWidth: '80%',
          }}
        >
          {message}
        </Typography>
        <Button variant="contained" color="primary" size="large" onClick={_onUpgrade}>
          Upgrade Now
        </Button>
      </Paper>
      {upgradeDialogOpen && (
        <UpgradeDialog open={upgradeDialogOpen} onClose={() => setUpgradeDialogOpen(false)} />
      )}
    </Box>
  )
}

export default PermissionOverlay
